export const ECTO_PETROHUE_ID = 63827;
export const ECTO_TURBIDIRY_SENSOR_TYPE = ['turbidity'];
export const ECTO_TURBIDIRY_SENSORS = [759209];
export const ECTO_SOLIDS_SENSOR_TYPE = ['solids'];
export const ECTO_SOLIDS_SENSORS = [759211];
